import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Moon, Sun } from 'lucide-react';

/**
 * Animated dark/light mode toggle.
 * Usage: <ThemeToggle /> — drop it anywhere in a nav/header.
 */
export default function ThemeToggle({ className = '' }) {
    const { isDark, toggleTheme } = useTheme();

    return (
        <button
            type="button"
            onClick={toggleTheme}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            className={`theme-toggle-btn ${isDark ? 'dark' : 'light'} ${className}`}
            style={{ padding: 0 }}
        >
            {/* sliding thumb */}
            <span className="theme-toggle-thumb" />
            {/* icon overlay (positioned on active side) */}
            <span
                style={{
                    position: 'absolute',
                    top: '2px',
                    left: isDark ? '2px' : '18px',
                    width: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'left 0.25s cubic-bezier(.4,0,.2,1)',
                    pointerEvents: 'none',
                    zIndex: 1,
                }}
            >
                {isDark
                    ? <Moon size={13} color="#1a1612" strokeWidth={2.5} />
                    : <Sun  size={13} color="#fff"    strokeWidth={2.5} />
                }
            </span>
        </button>
    );
}
